/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, July 2020
 */

import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Paragraph, styled } from '@staffino/flow-controls';
import { DocumentViewerModal } from '@staffino/flow-screen';

const StyledLink = styled.a({
  display: 'inline-block',
  cursor: 'pointer',
  textDecoration: 'underline',
});

type Props = {
  color?: string;
  locale?: string;
  privacyPolicyUrl?: string;
};
const TosBlock = ({ color = 'lightText', locale, privacyPolicyUrl }: Props) => {
  const [documentIndex, setDocumentIndex] = useState(undefined);
  const { t } = useTranslation();
  const supportedLocale = ['sk', 'pl', 'tr', 'it', 'de'].includes(locale)
    ? locale
    : 'en';
  const documents = [
    {
      title: t('Privacy Policy'),
      url:
        privacyPolicyUrl ||
        `https://s3-eu-west-1.amazonaws.com/cdn-static.staffino.com/documents/web/privacy-policy.${supportedLocale}.html`,
    },
  ];

  return (
    <>
      {documentIndex !== undefined && (
        <DocumentViewerModal
          documents={documents}
          activeIndex={documentIndex}
          onChange={setDocumentIndex}
        />
      )}
      <Paragraph
        fontSize="0.875rem"
        textAlign="center"
        color={color ?? 'lightText'}
        mt={10}
        display="block"
      >
        <Trans>
          By submitting your feedback you confirm you were duly familiarised
          with the{' '}
          <StyledLink onClick={() => setDocumentIndex(0)}>
            Privacy Policy
          </StyledLink>
          .
        </Trans>
      </Paragraph>
    </>
  );
};

export default TosBlock;
